import '../sass/latest-research.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-schools-swiper-js');
    const $blocks = document.querySelectorAll('.block.latest-research.latest-research--carousel');

    if (!$blocks.length) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.latest-research__swiper');
        const $pagination = $block.querySelector('.latest-research__pagination');

        const initCarousels = () => {
            if (!$carousel) return;

            const swiperOptions = {
                slidesPerView: 'auto',
                spaceBetween: 30,
            };

            // Only enable bullet pagination when the element exists.
            if ($pagination) {
                swiperOptions.pagination = {
                    el: $pagination,
                    type: 'bullets',
                    clickable: true
                };
            }

            new Swiper($carousel, {
                ...swiperOptions
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousels();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousels();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-schools-swiper-js');

                if (!swiperScript) return;

                initCarousels();
            });
        }
    });
})();
